export const getConnectRpcHeaders = (token) => {
    const headers = new Headers();
    const authToken = 'Bearer ' + token;
    headers.set("Authorization", authToken);
    return {headers: headers}
}